/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type QnaSourceChitchatTypes = 'professional' | 'friendly' | 'witty' | 'caring' | 'enthusiastic';
type ChitchatUrlMapType = {
    [key: string]: {
        professional: string;
        friendly: string;
        witty: string;
        caring: string;
        enthusiastic: string;
    };
};

export const chitchatUrlMap: ChitchatUrlMapType = {
    en: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/english/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/english/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/english/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/english/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/english/qna_chitchat_enthusiastic.tsv'
    },
    fr: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/french/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/french/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/french/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/french/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/french/qna_chitchat_enthusiastic.tsv'
    },
    de: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/german/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/german/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/german/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/german/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/german/qna_chitchat_enthusiastic.tsv'
    },
    it: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/italian/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/italian/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/italian/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/italian/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/italian/qna_chitchat_enthusiastic.tsv'
    },
    ja: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/japanese/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/japanese/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/japanese/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/japanese/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/japanese/qna_chitchat_enthusiastic.tsv'
    },
    ko: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/korean/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/korean/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/korean/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/korean/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/korean/qna_chitchat_enthusiastic.tsv'
    },
    pt: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/portuguese/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/portuguese/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/portuguese/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/portuguese/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/portuguese/qna_chitchat_enthusiastic.tsv'
    },
    es: {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/spanish/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/spanish/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/spanish/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/spanish/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/spanish/qna_chitchat_enthusiastic.tsv'
    },
    'zh-hans': {
        professional: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/chinese_simplified/qna_chitchat_professional.tsv',
        friendly: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/chinese_simplified/qna_chitchat_friendly.tsv',
        witty: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/chinese_simplified/qna_chitchat_witty.tsv',
        caring: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/chinese_simplified/qna_chitchat_caring.tsv',
        enthusiastic: 'https://qnamakerstore.blob.core.windows.net/qnamakerdata/editorial/chinese_simplified/qna_chitchat_enthusiastic.tsv'
    }
};
